
        Component.define('youbuy-wrapper', (el, params) => {
            /**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

const $el   = $(el);

const $compararAba   = $el.find('[data-component=youbuy-comparar-aba]');
const $airplanesList = $el.find('[data-component=youbuy-airplanes]');
const $shareModal    = $('[data-component="share-modal"]');

const $form          = $airplanesList.find('form');
const $airplanes     = $airplanesList.find('.airplanes');

let compareVue;
let app;
let comparar = [];

axios
.get(root + 'wsyoubuy')
.then(function(response) {
    const categories  = response.data.categories;
    let allCategories = categories;
    let allModels     = response.data.models;
    let allProducers  = response.data.producers;
    let allAirplanes  = response.data.airplanes;

    if(localStorage.getItem('model')) {
        if (typeof JSON.parse(localStorage.getItem("model")) != 'object') {
            localStorage.clear();
        } else {
            comparar = Array.from(JSON.parse(localStorage.getItem("model")));
        }
    }

    $airplanes.addClass('active');

    compareVue = new Vue({
        el: '#comparar-aba',
        delimiters: ['${', '}'],
        data: {
            airplanes: null,
            showButton: false,
        },
        methods: {
            deleteComparar: function(id) {
                comparar = comparar.filter(function(value) {
                    return value != id;
                });

                if (comparar.length == 0) {
                    $compararAba.hide();
                } else if (comparar.length < 2) {
                    app.showComparar = true;
                    this.showButton  = false;
                } else {
                    this.showButton  = true;
                }

                this.airplanes = this.airplanes.filter(function(airplane, index) {
                    if (comparar.includes(airplane.id)) {
                        return airplane;
                    }
                });

                localStorage.setItem('model', JSON.stringify(comparar));
            },
        },
    });

    if (comparar.length > 0) {
        $compararAba.show();

        if (comparar.length < 2) {
            compareVue.showButton = false;
        } else {
            compareVue.showButton = true;
        }

        compareVue.airplanes = allAirplanes.filter(function(airplane, index) {
            if (comparar.includes(airplane.id)) {
                return airplane;
            }
        });
    }

    app = new Vue({
        el: '#app',
        delimiters: ['${', '}'],
        data: {
            selectedCategory: '',
            selectedModel: '',
            selectedProducer: '',
            selectedYear: '',
            selectedOrder: '',

            showComparar: true,
            categories: null,
            models: null,
            producers: null,
            years: null,
            airplanes: null,

            total        : 0,
            page         : 1,
            itensPerPage : 4,
        },
        methods: {
            changeForm: function(event) {
                let $interForm = $(this.$el).find('form');
                this.page = 1;
                $form.trigger('submit');
            },
            changeGrid: function(listType, classOut) {
                let $interAirplanes = $(this.$el).find('.airplanes');
                $(this.$el).find('.view-options a.' + classOut).removeClass('active');
                $(this.$el).find('.view-options a.' + listType).addClass('active');

                if (!$interAirplanes.hasClass(listType)) {
                    $interAirplanes.removeClass('list grid');
                    $interAirplanes.addClass(listType);

                    if (listType == 'list') {
                        this.itensPerPage = 4;
                    } else {
                        this.itensPerPage = 6;

                        const $gridItens = $interAirplanes.parent().find('.grid .item');
                        if ($gridItens.length > 0) {
                            const $infos = $gridItens.find('.content');
                            $infos.eqHeight($gridItens.length);
                        }
                    }

                    $form.trigger('submit');
                }
            },
            comparar: function(event, id) {
                $(event.toElement).addClass('disable');

                if (comparar.includes(id)) {
                    return false;
                }

                if (comparar.length < 2) {
                    comparar.push(id);
                    if (comparar.length >= 2) {
                        this.showComparar = false;
                        compareVue.showButton = true;
                    } else {
                        compareVue.showButton = false;
                    }

                    compareVue.airplanes = allAirplanes.filter(function(airplane, index) {
                        if (comparar.includes(airplane.id)) {
                            return airplane;
                        }
                    });

                    localStorage.setItem('model', JSON.stringify(comparar));
                    $('[data-component=youbuy-comparar-aba]').show();
                }
            },
            toogleShare: function(event) {
                const type = event.type;

                if (type == "mouseover") {
                    $(event.toElement).siblings('.pop-share').addClass('active');
                } else if (type == "mouseleave") {
                    $(event.fromElement).removeClass('active');
                }
            },
            share: function(type, id) {
                const URI   = root + 'youbuy/airplane/' + id;
                const desc  = 'Veja essa aeronave: ';
                const title = 'Youbuy';

                if (type == 'whatsapp') {
                    Share.whatsapp(URI);
                } else if (type == 'facebook') {
                    Share.facebook(URI);
                } else if (type == 'twitter') {
                    Share.twitter(URI, desc);
                } else if (type == 'linkedin') {
                    Share.linkedin(URI, title, desc);
                } else if (type == 'envie') {
                    $shareModal.trigger('modal:open', [URI]);
                }
            },
            addAirplane: function(airplane) {
                this.airplanes.push(airplane);
            },
            onLoadMore: function() {
                this.page++;
            },
            onClickCard: function(item) {
                $document.trigger('click-card', [item]);
            }
        },
        filters: {
            leftcomplete: function (value) {
                value = value.toString();
                value = value.padStart(3, '0');
                return value;
            }
        },
        mounted () {
            this.$nextTick(() => {
                comparar.forEach((value) => {
                    $('.item-' + value).find('.btn-comparar').addClass('disable');
                });

                const $this = $(this.$el);

                let triggerGrid = true;
                let gridActive = $this.find('.view-options a.active').attr('data-list-type');

                window.addEventListener('resize', () => {
                    const $gridItens = $this.find('.grid .item');

                    if ($gridItens.length > 0) {
                        const $infos = $gridItens.find('.content');
                        $infos.eqHeight($gridItens.length);
                    }

                    if (wW < 768 && triggerGrid) {
                        gridActive = $this.find('.view-options a.active').attr('data-list-type');
                        this.changeGrid('grid', 'list');
                        $this.find('.view-options').hide();

                        triggerGrid = false;
                    } else if (wW > 767 && !triggerGrid) {
                        let classOut = 'grid';
                        if (gridActive == 'grid') {
                            classOut = 'list';
                        }

                        this.changeGrid(gridActive, classOut);
                        $this.find('.view-options').show();

                        triggerGrid = true;
                    }
                });

                window.dispatchEvent(new Event('resize'));
            })
        }
    });

    if (comparar.length >= 2) {
        app.showComparar = false;
    }

    allModels = allModels.filter(function(model, index) {
        if (allAirplanes.find(o => o.model == model.id)) {
            return model;
        }
    });

    allCategories = allCategories.filter(function(category, index) {
        if (allModels.find(o => o.category == category.id)) {
            return category;
        }
    });

    allProducers = allProducers.filter(function(producer, index) {
        if (allModels.find(o => o.producer == producer.id)) {
            return producer;
        }
    });

    allAirplanes = allAirplanes.map(obj => {
        if (obj.images) {
            Object.assign(obj, {thumb: JSON.parse(obj.images)[0].image});
        }

        obj.model = (allModels.find(o => o.id == obj.model));

        return obj;
    });

    const years = [...(new Set(allAirplanes.map(({ year }) => year)))];
    years.sort();

    // console.log(JSON.parse(allAirplanes[5].images)[0].image);
    $form.on('submit', function(e) {
        e.preventDefault();

        let filtered_airplanes  = allAirplanes;
        let filtered_categories = allCategories;
        let filtered_models     = allModels;
        let filtered_producers  = allProducers;

        if (app.selectedYear) {
            filtered_airplanes = filtered_airplanes.filter((item) => app.selectedYear == item.year);
        }

        if (app.selectedCategory) {
            filtered_airplanes = filtered_airplanes.filter((item) => app.selectedCategory == item.model.category);
            filtered_models    = filtered_models.filter((item) => app.selectedCategory == item.category);
        }

        if (app.selectedProducer) {
            filtered_airplanes = filtered_airplanes.filter((item) => app.selectedProducer == item.model.producer);
            filtered_models    = filtered_models.filter((item) => app.selectedProducer == item.producer);
        }

        if (app.selectedModel) {
            filtered_airplanes = filtered_airplanes.filter((item) => app.selectedModel == item.model.id);
        }

        if (app.selectedOrder) {
            if (app.selectedOrder == 'newYear') {
                filtered_airplanes.sort(function (a, b) {
                    if (a.year < b.year) {
                        return 1;
                    }
                    if (a.year > b.year) {
                        return -1;
                    }
                    return 0;
                });
            }
            if (app.selectedOrder == 'oldYear') {
                filtered_airplanes.sort(function (a, b) {
                    if (a.year > b.year) {
                        return 1;
                    }
                    if (a.year < b.year) {
                        return -1;
                    }
                    return 0;
                });
            }
            if (app.selectedOrder == 'lessHours') {
                filtered_airplanes.sort(function (a, b) {
                    if (a.flightHour > b.flightHour) {
                        return 1;
                    }
                    if (a.flightHour < b.flightHour) {
                        return -1;
                    }
                    return 0;
                });
            }
            if (app.selectedOrder == 'moreHours') {
                filtered_airplanes.sort(function (a, b) {
                    if (a.flightHour < b.flightHour) {
                        return 1;
                    }
                    if (a.flightHour > b.flightHour) {
                        return -1;
                    }
                    return 0;
                });
            }
            if (app.selectedOrder == 'smallerPrice') {
                filtered_airplanes.sort(function (a, b) {
                    if (a.price == '' || b.price == '') {
                        return 0;
                    }

                    if (parseInt(a.price.replace('.','').replace('.','')) > parseInt(b.price.replace('.','').replace('.',''))) {
                        return 1;
                    } else {
                        return -1;
                    }
                });
            }
            if (app.selectedOrder == 'biggerPrice') {
                filtered_airplanes.sort(function (a, b) {
                    if (a.price == '' || b.price == '') {
                        return 0;
                    }

                    if (parseInt(a.price.replace('.','').replace('.','')) < parseInt(b.price.replace('.','').replace('.',''))) {
                        return 1;
                    } else {
                        return -1;
                    }
                });
            }
        }

        app.total = filtered_airplanes.length;

        if(app.page > 1) {
            let nextindex = app.itensPerPage * app.page;
            filtered_airplanes = filtered_airplanes.slice(nextindex - app.itensPerPage, nextindex);

            $(filtered_airplanes).each(function(i, e) {
                app.addAirplane(e);
            });
        } else {
            filtered_airplanes = filtered_airplanes.slice(0, app.itensPerPage);
            app.airplanes = filtered_airplanes;
        }

        if (filtered_airplanes.length < app.itensPerPage || (app.page * app.itensPerPage) >= allAirplanes.length ) {
            $('.load').hide();
        } else {
            $('.load').show().removeClass('clicked').find('span').text('carregar mais');
        }

        app.categories = filtered_categories;
        app.models     = filtered_models;
        app.producers  = filtered_producers;
        app.years      = years;
    }).trigger('submit');

    $airplanesList.on('click', '.load', function(){
        $(this).addClass('clicked');
        $(this).find('span').html('carregando...');
        $form.trigger('submit');

        return false;
    });
});

        });